export default __webpack_public_path__ + "static/media/star-grey.3c38b0aa.svg";